<div class="relative w-full h-full">
  <!-- Close button -->
  <button
    class="absolute top-2 right-2 z-50 w-8 h-8 flex items-center justify-center bg-e-black-text bg-opacity-60 hover:bg-opacity-80 text-white rounded-full shadow-lg border border-e-white-text/20 transition-all duration-200 transform hover:scale-110"
    (click)="dialogRef.close()"
    matTooltip="Close"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>

  <!-- Image carousel -->
  <div class="relative rounded-lg overflow-hidden image_carousel_container">
    <ng-container *ngFor="let image of data; let i = index">
      <div
        [class.hidden]="currentIndex !== i"
        class="duration-700 ease-in-out w-full flex items-center justify-center"
        data-carousel-item
      >
        <img [src]="image" class="object-contain max-h-[85vh]" alt="Image" />
      </div>
    </ng-container>
  </div>

  <!-- Navigation buttons -->
  <ng-container *ngIf="data.length > 1">
    <!-- Previous button -->
    <button
      type="button"
      (click)="showPrevious()"
      class="absolute top-1/2 -translate-y-1/2 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      data-carousel-prev
    >
      <span
        class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-e-black-text/30 group-hover:bg-e-black-text/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none"
      >
        <svg
          class="w-4 h-4 text-white rtl:rotate-180"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 1 1 5l4 4"
          />
        </svg>
        <span class="sr-only">Previous</span>
      </span>
    </button>

    <!-- Next button -->
    <button
      type="button"
      (click)="showNext()"
      class="absolute top-1/2 -translate-y-1/2 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      data-carousel-next
    >
      <span
        class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-e-black-text/30 group-hover:bg-e-black-text/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none"
      >
        <svg
          class="w-4 h-4 text-white rtl:rotate-180"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 9 4-4-4-4"
          />
        </svg>
        <span class="sr-only">Next</span>
      </span>
    </button>

    <!-- Image counter -->
    <div
      class="absolute top-2 left-2 text-white text-sm bg-e-black-text bg-opacity-60 px-3 py-1 rounded-full"
    >
      {{ currentIndex + 1 }} / {{ data.length }}
    </div>
  </ng-container>
</div>
